import { KpiRow } from '../components/KpiRow';
import { MultiBrandTrendChart } from '../components/MultiBrandTrendChart';
import { BrandLeaderboard } from '../components/BrandLeaderboard';
import { DomainTypeDonut } from '../components/DomainTypeDonut';
import { OnboardingStrip } from '../components/OnboardingStrip';
import { TopDomainsPanel } from './shared/TopDomainsPanel';
import type { MeasurementPage } from '../shell-types';

interface Props {
  onGoto: (page: MeasurementPage) => void;
}

export function OverviewPage({ onGoto }: Props) {
  return (
    <div className="space-y-5">
      <OnboardingStrip onGoto={onGoto} />
      <KpiRow />
      <div className="grid gap-5 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <MultiBrandTrendChart />
        </div>
        <BrandLeaderboard limit={7} />
      </div>
      <div className="grid gap-5 lg:grid-cols-3">
        <div className="lg:col-span-2">
          <TopDomainsPanel limit={10} />
        </div>
        <DomainTypeDonut />
      </div>
    </div>
  );
}
